import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFifty(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M3.125 2.5h17.75c.345 0 .625.28.625.625v8.1C20.642 10.18 19.403 9.5 17.75 9.5c-1.873 0-3.21.862-4.066 2.143V9.5H5.381v7.05l1.795.48c.725-.7 1.54-.995 2.538-.995 1.378 0 2.175.737 2.175 1.823 0 .994-.816 1.822-2.248 1.822-1.269 0-2.393-.478-3.209-1.343L5 20.159A5.275 5.275 0 0 0 6.91 21.5H3.125a.625.625 0 0 1-.625-.625V3.125c0-.345.28-.625.625-.625ZM0 3.125C0 1.399 1.4 0 3.125 0h17.75C22.601 0 24 1.4 24 3.125v17.75C24 22.601 22.6 24 20.875 24H3.125A3.125 3.125 0 0 1 0 20.875V3.125Zm10.62 10.646a3.99 3.99 0 0 1 2.029.542c.166-.91.474-1.774.933-2.512H7.955v3c.58-.588 1.56-1.03 2.665-1.03Zm9.88 2.22c0 2.252-.684 4.009-2.49 4.009-1.826 0-2.51-1.757-2.51-4.01 0-2.25.684-3.99 2.51-3.99 1.806 0 2.49 1.74 2.49 3.99Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
